import TextInput, { TextInputProps } from '../TextInput';
import React, { forwardRef } from 'react';

interface NumberInputProps extends TextInputProps {
  maxLength?: number;
}

const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>((props, ref) => {
  const keyDownHandler = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (
      event.getModifierState('Meta') ||
      event.getModifierState('Control') ||
      event.getModifierState('Alt')
    ) {
      return;
    }

    if (event.key.length !== 1 || event.key === '\x00') {
      return;
    }

    if (!new RegExp('\\d').test(event.key)) {
      event.preventDefault();
    }
  };

  return (
    <TextInput
      {...props}
      inputProps={{
        ...props.inputProps,
        maxLength: props.maxLength,
        onKeyDown: keyDownHandler,
        pattern: '\\d*'
      }}
      ref={ref}
    />
  );
});

export default NumberInput;
